import { render, staticRenderFns } from "./BenifitsAdditionalSpouseWidget.vue?vue&type=template&id=91cd6984&scoped=true"
import script from "./BenifitsAdditionalSpouseWidget.vue?vue&type=script&lang=js"
export * from "./BenifitsAdditionalSpouseWidget.vue?vue&type=script&lang=js"
import style0 from "./BenifitsAdditionalSpouseWidget.vue?vue&type=style&index=0&id=91cd6984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cd6984",
  null
  
)

export default component.exports